import SupplyAlertProfileTable from "./view/SupplyAlertProfileTable";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { useRecoilValue } from "recoil";
import { PERMISSIONS } from "../../../PermissionsConstants";

const LeasedEquipmentSupplyAlertProfile = () => {
  const viewPermission =
      PERMISSIONS.permission_utilities_leasedequipment_supplyalertprofile_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  return <>{userPermissions.includes(viewPermission) ? <SupplyAlertProfileTable /> : ""}</>;
};

export default LeasedEquipmentSupplyAlertProfile;
